import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, ref } from "vue";
  import { QInput } from "quasar";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberInput',
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const rules = computed(() => [
    (val: string) => (props.required && !!val) || !props.required || "Required",
    (val: string) => (val.length >= 1 && val.substring(0, 1) === "0") || (!props.required && !val) || "Must be start with 0",
    (val: string) => !isNaN(Number(val)) || "Invalid format",
    (val: string) => (props.required && val.length >= 10 ) || ( (!props.required && (val.length == 0 || val.length >= 10))) || "Invalid length"
  ])

  const value = computed<string>({
    get() {
      if (props.modelValue) {
        return props.modelValue.replace(/\s/g, '')
      }
      else {
        return ""
      }
    },
    set(value: string) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit
  
  const mobileNumberRef = ref<QInput | null>(null);
  function validate() {
    const valid = mobileNumberRef.value!.validate();
    return valid;
  }
  __expose({
    validate
  })

  function onBlur(event: Event) {
    if ((event.target! as HTMLInputElement).value === "") {
      emit('update:modelValue', "")
    }
  }
  function restrictInput(event: KeyboardEvent, val: string) {
    if (!/[0-9]/.test(val[val.length - 1])) {
      emit('update:modelValue', val.slice(0, -1));
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_unref(QInput), {
      outlined: "",
      dense: "",
      ref_key: "mobileNumberRef",
      ref: mobileNumberRef,
      modelValue: value.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      pattern: "[0-9]{11}",
      maxlength: "11",
      type: "tel",
      onBlur: onBlur,
      placeholder: __props.placeholder,
      rules: rules.value,
      "lazy-rules": "",
      class: "tw-shadow-sm",
      onKeyup: _cache[1] || (_cache[1] = ($event: any) => (restrictInput($event, value.value)))
    }, _createSlots({ _: 2 }, [
      (__props.icon)
        ? {
            name: "prepend",
            fn: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "mdi-cellphone" })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "placeholder", "rules"])
  ], 64))
}
}

})